import { useContext } from 'react'

import { Form } from 'components/Form'
import Loading from 'components/Loading'
import { AddEditDomainContext } from 'features/inventory/domain/contexts/AddEditDomainContext'
import { useUpdateDomainKWords } from 'features/inventory/domain/forms/RichPlacementsForm/hooks/useUpdateDomainKWords/useUpdateDomainKWords'
import { schema, Schema, schemaDefault } from './schema'
import { KWordsSection } from './Section'

export const KWordsForm = (): React.JSX.Element => {
  const {
    domain,
    formId,
    loading: isFetching,
    setTouched,
    setValid,
  } = useContext(AddEditDomainContext)
  const { errors, isPending: isUpdating, update } = useUpdateDomainKWords()

  if (!domain) {
    return <Loading />
  }

  return (
    <Form<Schema>
      externalErrors={errors}
      id={formId}
      loading={isFetching || isUpdating}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={schema}
      schemaDefaults={schemaDefault(domain)}
    >
      {() => <KWordsSection />}
    </Form>
  )
}
